// src/data/localizeCondition.js
// Per-language overrides for conditionContent. English objects are the source
// of truth; each JSON maps slug -> translated fields (name, title, intro,
// stats, metaDescription, howNinoaHelps, commonTriggers, helperFoods, ctaText).
import de from "./conditionContent.de.json";
import es from "./conditionContent.es.json";
import ka from "./conditionContent.ka.json";

const OVERRIDES = { de, es, ka };

export default function localizeCondition(condition, language) {
    if (!condition) return condition;
    const lang = (language || "en").split("-")[0];
    const override = OVERRIDES[lang] && OVERRIDES[lang][condition.slug];
    return override ? { ...condition, ...override } : condition;
}
